// extracted by mini-css-extract-plugin
export default {"layout":"ModalLayout_layout__NlmCY"};